import React from "react"
import styled from "styled-components"

const BannerWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`

const BannerText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #333;
  flex: 1;
`

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
`

const Button = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`

const AcceptButton = styled(Button)`
  background: var(--primary, #95c01f);
  color: #fff;
`

const DeclineButton = styled(Button)`
  background: #eee;
  color: #000;
`

const COOKIE_CONSENT_KEY = "mds_cookie_consent"

const CookieBanner = () => {
  const [visible, setVisible] = React.useState(false)

  React.useEffect(() => {
    setVisible(!localStorage.getItem(COOKIE_CONSENT_KEY))
  }, [])

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted")
    setVisible(false)
  }

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "refused")
    setVisible(false)
  }

  if (!visible) return null

  return (
    <BannerWrapper id="cookie-banner-wrapper">
      <BannerText>
        Ce site utilise des cookies pour améliorer votre expérience.
      </BannerText>
      <ButtonGroup>
        <DeclineButton id="cookie-decline" onClick={handleDecline}>
          Refuser
        </DeclineButton>
        <AcceptButton id="cookie-accept" onClick={handleAccept}>
          Accepter
        </AcceptButton>
      </ButtonGroup>
    </BannerWrapper>
  )
}

export { CookieBanner }
